import { c as _c } from "react/compiler-runtime";
import EventsSkeleton from 'modules/main/components/event-box-section/events-skeleton';
import { EventBoxSectionProps } from 'modules/main/components/event-box-section/types';
import RenderEvent from 'modules/main/components/render-event';
import { useMain } from 'modules/main/hooks/use-main';
import { MainEventType } from 'modules/main/types/main-interface';
import React, { useEffect, useState } from 'react';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const EventBoxSection = React.forwardRef<HTMLDivElement, React.PropsWithChildren<EventBoxSectionProps>>(function EventBoxSection(t0, ref) {
  const $ = _c(20);
  const {
    filter
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const {
    events,
    revenue
  } = useMain(filter);
  const [eventsData, setEventsData] = useState(null);
  let t1;
  let t2;
  if ($[0] !== events) {
    t1 = () => {
      if (events) {
        setEventsData(events.items);
      }
    };
    t2 = [events];
    $[0] = events;
    $[1] = t1;
    $[2] = t2;
  } else {
    t1 = $[1];
    t2 = $[2];
  }
  useEffect(t1, t2);
  const hasEvents = eventsData?.length !== 0;
  let t3;
  if ($[3] !== t) {
    t3 = t("dashboard.main.event.title");
    $[3] = t;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t3) {
    t4 = <span className="text-text-primary font-inter px-[25px] py-[23px] text-[20px] font-bold">{t3}</span>;
    $[5] = t3;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <hr className="color-[rgb(var(--background-tertiary))] opacity-10" />;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== eventsData || $[9] !== hasEvents || $[10] !== revenue) {
    t6 = eventsData ? hasEvents && <><div className="flex flex-col gap-3 overflow-hidden px-[25px] pb-5"><ul className="flex flex-col">{eventsData.map((event, idx) => <li key={idx}><RenderEvent event={event} lastItem={idx === eventsData.length - 1} /></li>)}</ul></div></> : <EventsSkeleton revenueLength={Object.keys(revenue || []).length} />;
    $[8] = eventsData;
    $[9] = hasEvents;
    $[10] = revenue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t4 || $[13] !== t6) {
    t7 = <div className="static flex w-full flex-col lg:absolute">{t4}{t5}{t6}</div>;
    $[12] = t4;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] !== hasEvents) {
    t8 = hasEvents && <div className="absolute bottom-0 hidden h-[50px] w-[326px] rounded-lg bg-gradient-to-b from-[hsla(0,0%,100%,0)] to-[var(--color-background-secondary)] lg:block" />;
    $[15] = hasEvents;
    $[16] = t8;
  } else {
    t8 = $[16];
  }
  let t9;
  if ($[17] !== t7 || $[18] !== t8) {
    t9 = <div className="bg-background-secondary shadow-old-design relative min-h-[700px] w-full flex-none overflow-hidden rounded-lg lg:w-[326px]">{t7}{t8}</div>;
    $[17] = t7;
    $[18] = t8;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
});